import React, { Component } from 'react';
import Utils from '../../utils/Utils.js'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {getFeatureByTag} from 'reducers/features.js'
import UserService from 'services/UserService.js';
import SideBar, {width} from './SideBar.js';

class SideBarContainer extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.onSignOut = this.onSignOut.bind(this);
        this.includeLink = this.includeLink.bind(this);
    }
    
    componentWillMount() {
    }

    onClick(e) {
        e.preventDefault();
        var href = e.currentTarget.getAttribute('href');
        if(href.startsWith('http')) {
            window.location = href;
        } else {
            this.props.history.push(href);
            this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
        }
    }

    onSignOut(e){
        e.preventDefault();
        UserService.signOut();
    }

    links() {
        var links = [
                    {href:"/home",              title:"Home",            icon:"home"},
                    {href:"/profile",           title:"Profile",         iconClassName:"icon-profile"},
                    {href:"/newsfeed",          title:"News Feed",       iconClassName:"icon-news"},
                    {href:"/leaderboards",      title:"Leaderboards",    iconClassName:"icon-leaderboard"},
                    {href:"/team-challenges",    title:"Team Challenge",  iconClassName:"icon-team"},
                    {href:"/connections",       title:"Connect Devices", iconClassName:"icon-signal"},
                    {href:"/rewards",           title:"Rewards",         iconClassName:"icon-rewards"},
                    {href:"/settings",          title:"Settings",        iconClassName:"icon-gear"},
                    {href:"/invitations",       title:"Invite Friends",  iconClassName:"icon-paper-clip"},
                    {href:"mailto:support@myoptimity.com",          title:"Feedback",        iconClassName:"icon-news"},
                    {href:"https://myoptimity.cnflx.io/public",           title:"Request Feature",         iconClassName:"icon-inbox3"},
                    {href:"/",                  title:"Sign Out",        iconClassName:"icon-power", onClick:this.onSignOut},
        ];
        return links.filter(this.includeLink).map((link)=>({...link, className:(link.href==this.props.location.pathname ? 'active item' : 'item'  )}));
    }

    includeLink(link) {
        if(!this.props.teamChallengeFeature && link.href==='/team-challenges') {
            return false; 
        }
        return true;
    }
    
    render() {
        return (
            <SideBar links={this.links()}
                     style={this.props.style}
                     enable={this.props.enable}
                     userProfile={this.props.userProfile}
                     onClick={this.onClick}
                     avatarUrl={Utils.deref(this.props.userProfile, 'avatar.url') || ''} />
        );
    }
}

function mapStateToProps(state, ownProps) {
    var userProfile = {firstName:'', lastName:'', team:{name:''}, company:{name:''}};

    if(state.user.userProfile) {
        userProfile = {...userProfile, ...state.user.userProfile}; 
    }
    if(userProfile.team==null) {
        userProfile.team = {name:''};
    }
    if(userProfile.company==null) {
        userProfile.company = {name:''};
    }

    var teamChallengeFeature = getFeatureByTag(state.features, 'optimity_team_challenge'); 

    return { userProfile                : userProfile, 
             enable                     : state.sidebar.enable, 
             teamChallengeFeature : teamChallengeFeature};
}

export {width};
export default withRouter(connect(mapStateToProps)(SideBarContainer));



// WEBPACK FOOTER //
// ./src/modules/navigation/SideBarContainer.js